import { useContext, createContext, useState, useEffect } from "react";

import miAxios from "../api/axios";

import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    let mToken = localStorage.getItem("token") || ""
    const [estaLogueado, setEstaLogueado] = useState((mToken.length > 0 ? true : false))
    const [proveedor, setProveedor] = useState(localStorage.getItem("proveedor") || "0")
    const [usuario, setUsuario] = useState(localStorage.getItem("usuario") || "0")
    const [sesion, setSesion] = useState(localStorage.getItem("sesion") || "0")
    const [token, setToken] = useState(mToken)
    const [nombre, setNombre] = useState(localStorage.getItem("nombre") || "")
    const [usuarioNombre, setUsuarioNombre] = useState(localStorage.getItem("usuario_nombre") || "")

    const menuGrupos = [
        { id: 1, texto: "Promoción", seleccion: true },
        { id: 2, texto: "Consultas", seleccion: false },
        { id: 3, texto: "Procesos", seleccion: false },
        { id: 4, texto: "Reportes", seleccion: false },
        { id: 5, texto: "Configuración", seleccion: false }
    ]

    const [menu, setMenu] = useState([])

    const zmenu = [
        { id: 0, texto: "Dashboard", grupo: 0, opcion: "/dashboard", permiso: 1},
        { id: 1, texto: "Videos promoción", grupo: 1, opcion: "/videos", permiso: 2 },
        { id: 5, texto: "Nuestro catálogo", grupo: 1, opcion: "/catalogo", permiso: 3 },
        { id: 6, texto: "Reacciones", grupo: 1, opcion: "/reacciones", permiso: 4 },
        { id: 3, texto: "Despachos", grupo: 3, opcion: "/despachos", permiso: 5 },
        { id: 7, texto: "Despachos", grupo: 4, opcion: "/reportes/proveedores_despachos", permiso: 6 },
        { id: 9, texto: "Histórico Ordenes", grupo: 2, opcion: "/ordenes", permiso: 7 },
        { id: 8, texto: "Histórico Despachos", grupo: 2, opcion: "/transacciones", permiso: 8 },
        { id: 14, texto: "Actualizar mis datos", grupo: 5, opcion: "/datos", nivel: 1, permiso: 9 },
        { id: 16, texto: "Cambiar mi contraseña", grupo: 5, opcion: "/", nivel: 2, permiso: 10 },
        { id: 17, texto: "Usuarios", grupo: 5, opcion: "/usuarios", nivel: 2, permiso: 12 },
        { id: 15, texto: "Cerrar sesión", grupo: 5, opcion: "/", nivel: 1, permiso: 0},
    ]

    const navigate = useNavigate()

    const handleLogout = () => {
        console.log("cerrando sesion...")
        setEstaLogueado(false)
        setProveedor(0)
        setUsuario(0)
        setSesion(0)
        setToken("")
        setNombre("")
        setUsuarioNombre("")
        localStorage.setItem("proveedor", "0")
        localStorage.setItem("usuario", "0")
        localStorage.setItem("sesion", "0")
        localStorage.setItem("token", "")
        localStorage.setItem("nombre", "")
        localStorage.setItem("usuario_nombre", "")
        navigate("/login")
    }

    const axios = miAxios(handleLogout)

    const handleLogin = async (proveedor, usuario, clave) => {
        let resultado = {
            respuesta: "N",
            mensaje: "",
            error: 0
        }
        try {
            const response = await axios.post("login/verify_proveedor", {
                proveedor: proveedor,
                usuario: usuario,
                clave: clave
            }, {
                withCredentials: true
            })
            const data = response.data;
            console.log("respuesta login", data)
            if (data.respuesta == "S") {
                setProveedor(data.proveedor)
                setUsuario(data.usuario)
                setToken(data.accessToken)
                setNombre(data.nombre)
                setUsuarioNombre(data.usuario_nombre)
                setSesion(data.sesion)
                localStorage.setItem("proveedor", data.proveedor)
                localStorage.setItem("usuario", data.usuario)
                localStorage.setItem("sesion", data.sesion)
                localStorage.setItem("token", data.accessToken)
                localStorage.setItem("nombre", data.nombre)
                localStorage.setItem("usuario_nombre", data.usuario_nombre)
                setEstaLogueado(true)
                resultado = {
                    ...resultado,
                    respuesta: "S"
                }
            } else {
                setEstaLogueado(false)
                resultado = {
                    ...resultado,
                    respuesta: data.respuesta,
                    mensaje: data.mensaje,
                    error: data.error
                }
            }
        } catch (error) {
            console.log(error)
            setEstaLogueado(false)
            resultado = {
                ...resultado,
                respuesta: "N",
                mensaje: error,
                error: -1
            }
        }
        return resultado
    }

    useEffect(() => {
        if (usuario && usuario !== "0" && estaLogueado && token) {
            const llamarAPI = async () => {
                try {
                    const response = await axios.get("usuarios/prov-permisos-lista?usuario=" + usuario);
                    const data = response.data;
                    console.log(data)
                    if (data.respuesta == "S") {
                        const n = data.lista.filter((r) => r.marca == 1).map((item) => {
                            return {
                                id: item.id
                            }
                        })
                        let mm = []
                        zmenu.forEach((r) => {
                            let permitido = false;
                            if (r.permiso == 0) {
                                permitido = true
                            } else {
                                n.forEach((s) => {
                                    if (s.id == r.permiso) {
                                        permitido = true
                                    }
                                })
                            }

                            if (permitido) {
                                mm.push(r)
                            }
                        })
                        console.log("permisos", mm)
                        setMenu(mm)

                    }
                } catch (error) {
                    console.error("Error al llamar API cuando cambió usuario:", error);
                }
            };

            llamarAPI();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usuario, estaLogueado, token]);


    return (
        <AuthContext.Provider value={{ proveedor, usuario, token, handleLogin, nombre, usuarioNombre, sesion, estaLogueado, handleLogout, menuGrupos, menu }}>
            {children}
        </AuthContext.Provider>
    )
};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
}